/** What the caller may do in a workspace (upload, change, delete; the file and row limits). */
import { useQuery } from '@tanstack/react-query';
import { uploadService } from '@/services/upload.service';

export function useUploadRights(workspace: string, enabled = true) {
  return useQuery({
    queryKey: ['uploadRights', workspace],
    queryFn: () => uploadService.rights(workspace),
    enabled,
    retry: false,
    staleTime: 5 * 60 * 1000,
  });
}
